import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SocialLinksComponent } from './social-links/social-links.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule],
  declarations: [SocialLinksComponent],
  exports: [SocialLinksComponent]
})
export class SharedFeatureSocialLinksModule {}
